import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px 0px",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    pointerEvents: "auto",
    borderRadius: "0px",
    backgroundColor: "#323232 !important",
    width: 200,
  },
  paper_user: {
    borderRadius: "0px",
    backgroundColor: "#323232 !important",
    width: 120,
  },
  paperNavMenu: {
    borderRadius: "0px",
    backgroundColor: "#323232 !important",
    width: 250,
  },
  userPopover: {
    outline: "none !important",
    border: "0",
    background: "transparent !important",
    cursor: "pointer",
  },
  navBar: {
    flexGrow: 1,
  },
  linkButton: {
    borderLeft: "none",
    border: "1px solid #669313",
    color: "white",
    fontSize: "1.1rem",
    padding: "0.5rem 1rem",
    outline: "none !important",
    backgroundImage: "linear-gradient(#a2c820, #669313)",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundImage: "linear-gradient( #669313, #a2c820)",
      color: "white",
    },
  },
  dropButton: {
    fontWeight: 600,
    border: "none",
    borderBottom: "1px solid black",
    backgroundColor: "inherit !important",
    color: "white",
    fontSize: "1rem",
    padding: "0.5rem 1rem",
    width: "100%",
    outline: "none !important",
    textAlign: "left",
    "&:hover": {
      color: "#fbe702",
    },
  },
  whiteButton: {
    border: "none",
    backgroundColor: "inherit",
    display: "block",
    color: "white",
    fontSize: "1rem",
    outline: "none !important",
    padding: "0.5rem 1rem",
    whiteSpace: "nowrap",
  },
}));
